import React, { useState, useRef } from "react";
import { useNavigate, Link, useAsyncError } from "react-router-dom";
import Form from "react-validation/build/form";
import FormBoot from "react-bootstrap/Form";
import { TextField } from "@mui/material";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import { isEmail } from "validator";
import Modal from "react-bootstrap/Modal";
import icon from "../../picture/LOGO_Dronesign.png";
import validator from "validator";
import AuthService from "../../services/auth.service";
import AuthServiceV2 from "../../services/auth.serviceV2";
import thaiIdCard from "thai-id-card";
import cancel from "../../picture/cancel.png";
import check from "../../picture/check.png";
import spin from "../../picture/Spin.gif";
import { Button, Row, Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import Static_modal from "../user/etc/Static_modal";

const validate = (value) => {
  if (
    validator.isStrongPassword(value, {
      minLength: 8,
      minLowercase: 1,
      minUppercase: 1,
      minNumbers: 1,
      minSymbols: 1,
    })
  ) {
    return <div className="valid-feedback d-block">Is Strong Password</div>;
  } else {
    return (
      <div className="invalid-feedback d-block">Is Not Strong Password</div>
    );
  }
};
const validateconfirmpassword = (value) => {
  //console.log(value);
  if (value === 1) {
    //console.log("yes");
    return <div className="valid-feedback d-block">Password match</div>;
  } else {
    //console.log("not");
    return <div className="invalid-feedback d-block">Password not match</div>;
  }
};
const required = (value) => {
  if (!value) {
    return (
      <div className="invalid-feedback d-block">This field is required!</div>
    );
  }
};

const validEmail = (value) => {
  if (!isEmail(value)) {
    return (
      <div className="invalid-feedback d-block">This is not a valid email.</div>
    );
  }
};

const vusername = (value) => {
  if (value.length < 2 || value.length > 20) {
    return (
      <div className="invalid-feedback d-block">
        The username must be between 2 and 20 characters.
      </div>
    );
  }
};

const Register = (props) => {
  const form = useRef();
  const [vpassword, setvpassword] = useState();
  const checkBtn = useRef();
  const [formType, setFormType] = useState(1);
  const [regisfail, setRegisfail] = useState(false);
  const [regissuccess, setRegissuccess] = useState(false);
  const [errorin, setErrorin] = useState(false);
  const [checkpassworderror, setcheckpassworderror] = useState(false);
  const [idnum, setIdnum] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [confirmpassword, setConfirmpasswordPassword] = useState("");
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [successful, setSuccessful] = useState(false);
  const [message, setMessage] = useState("");
  const [idnumcheck, setIdnumcheck] = useState("");
  const [juristicID, setJuristicID] = useState("");
  const [branchID, setBranchID] = useState("");
  const [identiy, setIdentity] = useState("");
  const [company_name, setCompany_name] = useState("");

  const [checkresendemail, setCheckresendmail] = useState(false);

  const [juristic_type, setJuristic_type] = useState(false); ///[normal:1 , Sar : 2]
  const [juris_display, setJuris_display] = useState("ทั่วไป"); ///[(ทั่วไป) , (Sar)]
  const [spinner, setSpinner] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [modalToggle, setModalToggle] = useState({
    modalSuccess: false,
    modalDenied: false,
    modalErr: false,
    modalwait: false,
  });
  const [textBody, setTextBody] = useState();
  const navigate = useNavigate();
  const handleClose_Modal = (close) => {
    setModalToggle({
      ...modalToggle,
      modalSuccess: close,
      modalDenied: close,
      modalErr: close,
      modalwait: close,
    });
    setTextBody("");
  };
  const onChangeEmail = (e) => {
    const email = e.target.value;
    setEmail(email);
  };
  const onChangePhone = (e) => {
    const phone = e.target.value;
    setPhone(phone);
  };
  const onChangeIdnum = (e) => {
    const idnum = e.target.value;
    const result = thaiIdCard.verify(idnum);
    //console.log(result);
    setIdnum(idnum);
    setIdnumcheck(result); //โค้ดถูกใส่ result
  };
  const handleresend = () =>{
    AuthServiceV2.newverify(
      email,
    )
      .then((response) => {
        setCheckresendmail(true)
        setSpinner(false);
       
      })
  }
  const onChangePassword = (e) => {
    const passwords = e.target.value;
    //console.log(passwords);
    validate(e.target.value);
    setPassword(passwords);
  };
  const onChangeconfirmpassword = (e) => {
    const confirmpasswordss = e.target.value;
    setConfirmpasswordPassword(confirmpasswordss);
    //console.log(password);
    //console.log(confirmpasswordss);
    if (password !== confirmpasswordss) {
      //console.log("not");
      validateconfirmpassword(0);
    } else {
      //console.log("yes");
      validateconfirmpassword(1);
    }
  };
  const onChangefirstname = (e) => {
    const firstname = e.target.value;
    setFirstname(firstname);
  };
  const onChangelastname = (e) => {
    const lastname = e.target.value;
    setLastname(lastname);
  };
  // const checkpassword = () => {
  //   console.log(password);

  //   if (password === confirmpassword) {
  //     return <div className="valid-feedback d-block">Passwords match</div>;
  //   } else {
  //     return (
  //       <div className="invalid-feedback d-block">Passwords do not match</div>
  //     );
  //   }
  // };

  const onChangeJuristic = (e) => {
    setJuristicID(e.target.value);
  };
  const onChangeBranchID = (e) => {
    setBranchID(e.target.value);
  };
  const onChangeCompany_name = (e) => {
    setCompany_name(e.target.value);
  };
  const onChangeIdentity = (e) => {
    setIdentity(e.target.value);
  };
  const handleClose = () => {
    setRegisfail(false);
    setRegissuccess(false);
    setErrorin(false);
    setcheckpassworderror(false);
  };

  const handleChangeForm = () => {
    if (formType === 1) {
      setFormType(2);
    } else {
      setFormType(1);
    }
  };

  const checkBranID = (branchID) => {
    /// พี่ศุภชัยบังคับส่ง รหัสสาขา เลยเซ็ตเป็น -  ไปครับ
    if (branchID === "") {
      return "-";
    } else {
      return branchID;
    }
  };
  const handleRegister = (e) => {
    e.preventDefault();

    setMessage("");
    setSuccessful(false);
    // console.log(password);
    // console.log(confirmpassword);
    form.current.validateAll();
    console.log(form.current.validateAll());

    if (formType === 1) {
      if (password === confirmpassword) {
        setSpinner(true);
        console.log("pass");
        // console.log(email);
        // console.log(firstname);
        AuthServiceV2.register_user(
          email,
          firstname,
          lastname,
          idnum,
          phone,
          password,
          confirmpassword
        )
          .then((response) => {
            console.log(response);

            console.log(response);
            setSpinner(false);
            //setMessage(response.data.message);
            //setSuccessful(true);
            setRegissuccess(true);
            setTimeout(() => {
              setRegissuccess(false);
              navigate("/login");
            }, 3000);
            //navigate("/login");
            //window.location.reload();
          })
          .catch((error) => {
            setSpinner(false);
            const check_des_error = error.split(".")[0];
            console.log(check_des_error);
            if (check_des_error === "This email is already exist") {
              setErrorMsg("อีเมลถูกใช้ไปแล้ว");
              setErrorin(true);
            } else if (check_des_error === "This idnum is already exist") {
              setErrorMsg("บัตรประชาชนถูกใช้ไปแล้ว");
              setErrorin(true);
            } else if (check_des_error === "This phone is already exist") {
              setErrorMsg("เบอร์โทรศัพท์ถูกใช้ไปแล้ว");
              setErrorin(true);
            } else if (
              check_des_error ===
              "The password field must be at least 8 characters"
            ) {
              setErrorMsg(`-รหัสผ่านต้องมีตั้งแต่8ตัวขึ้นไป`);
              setErrorin(true);
            } else if (
              check_des_error ===
              "The password field must contain at least one uppercase and one lowercase letter"
            ) {
              setErrorMsg(`-ต้องมีตัวภาษาอังกฤษพิมพ์ใหญ่
              -ต้องมีตัวภาษาอังกฤษพิมพ์เล็ก
              -ต้องมีอักษรพิเศษ`);
              setErrorin(true);
            } else if (
              check_des_error ===
              "The password field must contain at least one symbol"
            ) {
              setErrorMsg(`-ต้องมีอักษรพิเศษ`);
              setErrorin(true);
            } else if (
              check_des_error ===
              "The password field must contain at least one number"
            ) {
              setErrorMsg(`-ต้องมีตัวเลข`);
              setErrorin(true);
            } else {
              setErrorMsg("กรุณากรอกข้อมูลให้ถูกต้อง ");
              setErrorin(true);
            }
            setTextBody(error);
            setModalToggle({ ...modalToggle, modalErr: true });

            setSpinner(false);
          });
      } else {
        setSpinner(false);
        console.log("passnotmatch");
        setcheckpassworderror(true);
      }
    } else {
      if (password === confirmpassword) {
        console.log("pass", juristic_type);
        setSpinner(true);
        let branID = checkBranID(branchID);
        console.log(branID);
        AuthServiceV2.registercor(
          identiy,
          juristicID,
          branID,
          company_name,
          juristic_type,
          password,
          confirmpassword
        )
          .then(
            (response) => {
              console.log(response);
              if (response.data.status === "error") {
                setTimeout(() => {
                  setSpinner(false);
                  if (
                    response.data.error_description === "Email already exists"
                  ) {
                    setErrorMsg("อีเมลถูกใช้ไปแล้ว");
                    setErrorin(true);
                  }
                  //else if(response.data.error_description === "User already exists"){
                  // setErrorMsg("อีเมลถูกใช้ไปแล้ว");
                  //setErrorin(true);
                  // }
                  else if (
                    response.data.error_description ===
                    "Legal entity number already exists"
                  ) {
                    setErrorMsg("เลขนิติบุคคลถูกใช้ไปแล้ว");
                    setErrorin(true);
                  } else if (
                    response.data.error_description ===
                    "The branch code field is required."
                  ) {
                    setErrorMsg("กรณีไม่มีรหัสสาขากรุณาใสเครื่องหมาย (-)");
                    setErrorin(true);
                  } else {
                    setErrorMsg("กรุณากรอกข้อมูลให้ถูกต้อง");
                    setErrorin(true);
                  }
                }, 500);
              } else {
                console.log(response);

                //setMessage(response.data.message);
                setSuccessful(true);
                setRegissuccess(true);
                setTimeout(() => {
                  setRegissuccess(false);
                  navigate("/login");
                }, 3000);
                //navigate("/login");
                //window.location.reload();
              }
            }
            // (error) => {
            //   const resMessage =
            //     (error.response &&
            //       error.response.data &&
            //       error.response.data.message) ||
            //     error.message ||
            //     error.toString();

            //   setMessage(resMessage);
            //   setSuccessful(false);
            // }
          )
          .catch((error) => {
            setTextBody(error);
            setModalToggle({ ...modalToggle, modalErr: true });

            // setSuccessful(true);
            // setRegissuccess(true);
            // setTimeout((e) => {
            //   setRegissuccess(false);
            //   navigate("/login");
            // }, 3000);
            //navigate("/login");
            //window.location.reload();
          });
      } else {
        console.log("passnotmatch");
        setcheckpassworderror(true);
      }
      setSpinner(false);
    }
  };

  //console.log(juris_display, juristic_type);
  return (
    <div
      //className="col-md-12"
      style={{
        backgroundImage:
          "linear-gradient(107.56deg, rgba(2, 62, 138, 0.85) 0%, rgba(0, 150, 199, 0.85) 100%)",
        //top: "-50px",
        width: "100%",
        height: "auto",
        position: "absolute",
      }}
    >
      <div
        className="card"
        style={{
          width: "400px",
          height: "auto",
          fontFamily: "Kanit",
          borderRadius: "20px",
          top: "20px",
          //maxHeight:"1500px"
        }}
      >
        <img src={icon} alt="profile-img" className="profile-img-card" />
        <div
          style={{
            width: "100%",
            height: "50px",
            borderRadius: "10px",
            marginLeft: "auto",
            boxShadow: "0px 2px 4px 1px rgba(0, 0, 0, 0.25)",
            marginRight: "auto",
            display: "flex",
          }}
        >
          {formType === 1 ? (
            <>
              <div
                style={{
                  width: "50%",
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "rgba(6, 123, 255, 0.2)",
                  boxShadow: "0px 0px 30px rgba(0, 0, 0, 0.1)",
                  borderRadius: "10px",
                  fontSize: "16px",
                }}
              >
                ขึ้นทะเบียนบุคคลทั่วไป
              </div>
              <div
                style={{
                  width: "50%",
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "16px",
                  cursor: "pointer",
                }}
                onClick={handleChangeForm}
              >
                ขึ้นทะเบียนนิติบุคคล
              </div>
            </>
          ) : (
            <>
              <div
                style={{
                  width: "50%",
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "16px",
                  cursor: "pointer",
                }}
                onClick={handleChangeForm}
              >
                ขึ้นทะเบียนบุคคลทั่วไป
              </div>
              <div
                style={{
                  width: "50%",
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "rgba(6, 123, 255, 0.2)",
                  boxShadow: "0px 0px 30px rgba(0, 0, 0, 0.1)",
                  borderRadius: "10px",
                  padding: "20px",
                  fontSize: "16px",
                }}
              >
                ขึ้นทะเบียนนิติบุคคล
              </div>
            </>
          )}
        </div>

        <Form onSubmit={handleRegister} ref={form}>
          <div>
            {formType === 1 ? (
              <>
                <div className="form-group">
                  <label htmlFor="idnum">บัตรประชาชน</label>
                  <Input
                    type="text"
                    className="form-control"
                    name="idnum"
                    value={idnum}
                    placeholder="123xxx456xxx7"
                    pattern="[0-9]*"
                    maxlength="13"
                    minLength="13"
                    onChange={onChangeIdnum}
                    validations={[required]}
                    style={{
                      borderRadius: "10px",
                      boxShadow: "0px 2px 4px 1px rgba(0, 0, 0, 0.25)",
                      color: "#000000",
                    }}
                  />

                  <label htmlFor="firstname">ชื่อ</label>
                  <Input
                    type="text"
                    className="form-control"
                    name="firstname"
                    placeholder="อัครเดช"
                    value={firstname}
                    onChange={onChangefirstname}
                    validations={[required, vusername]}
                    pattern="[\u0E00-\u0E7Fa-zA-Z]*"
                    style={{
                      borderRadius: "10px",
                      boxShadow: "0px 2px 4px 1px rgba(0, 0, 0, 0.25)",
                      color: "#000000",
                    }}
                  />

                  <label htmlFor="lastname">นามสกุล</label>
                  <Input
                    type="text"
                    className="form-control"
                    name="lastname"
                    placeholder="ราชสีคา"
                    value={lastname}
                    onChange={onChangelastname}
                    validations={[required, vusername]}
                    pattern="[\u0E00-\u0E7Fa-zA-Z]*"
                    style={{
                      borderRadius: "10px",
                      boxShadow: "0px 2px 4px 1px rgba(0, 0, 0, 0.25)",
                      color: "#000000",
                    }}
                  />

                  <label htmlFor="email">เบอร์โทรศัพท์</label>
                  <Input
                    type="text"
                    className="form-control"
                    name="text"
                    placeholder="088888888"
                    pattern="[0-9]{10}"
                    value={phone}
                    maxlength="10"
                    minlength="10"
                    onChange={onChangePhone}
                    validations={[required]}
                    style={{
                      borderRadius: "10px",
                      boxShadow: "0px 2px 4px 1px rgba(0, 0, 0, 0.25)",
                      color: "#000000",
                    }}
                  />

                  <label htmlFor="email">อีเมล</label>
                  <Input
                    type="email"
                    className="form-control"
                    name="email"
                    placeholder="domain@swart.com"
                    value={email}
                    onChange={onChangeEmail}
                    validations={[required, validEmail]}
                    style={{
                      borderRadius: "10px",
                      boxShadow: "0px 2px 4px 1px rgba(0, 0, 0, 0.25)",
                      color: "#000000",
                    }}
                  />
                  <label htmlFor="password">รหัสผ่าน</label>
                  <FormBoot.Control
                    required
                    type="password"
                    value={password}
                    onChange={onChangePassword}
                    validations={[required, validate]}
                    style={{
                      borderRadius: "10px",
                      boxShadow: "0px 2px 4px 1px rgba(0, 0, 0, 0.25)",
                      color: "#000000",
                    }}
                  />
                  {/* <TextField
                      hiddenLabel
                      id="password"
                      type="password"
                      variant="filled"
                      value={password}
                      onChange={onChangePassword}
                      style={{
                        borderRadius: "10px",
                        boxShadow: "0px 2px 4px 1px rgba(0, 0, 0, 0.25)",
                        color: "#000000",
                        width: "100%",
                        height:"10px"
                      }}
                    /> */}

                  <label htmlFor="password confirm">ยืนยันรหัสผ่าน</label>
                  <FormBoot.Control
                    required
                    className="form-control"
                    type="password"
                    value={confirmpassword}
                    onChange={onChangeconfirmpassword}
                    validations={[required]}
                    style={{
                      borderRadius: "10px",
                      boxShadow: "0px 2px 4px 1px rgba(0, 0, 0, 0.25)",
                      color: "#000000",
                    }}
                  />
                </div>
              </>
            ) : (
              <>
                <div className="form-group">
                  <div style={{ alignContent: "center" }}>
                    <Row style={{ justifyContent: "left", marginTop: "10px" }}>
                      <FormBoot.Group as={Col} md="4">
                        <label>หน่วยงาน : </label>
                      </FormBoot.Group>
                      <FormBoot.Group
                        as={Col}
                        md="3"
                        style={{ padding: "0px" }}
                      >
                        <FormBoot.Check
                          className="check-box"
                          id={`inline-checkbox-1`}
                          type="radio"
                          label="ทั่วไป"
                          name="radioGroup"
                          defaultChecked={juristic_type === false}
                          onChange={(e) => {
                            setJuristic_type(!juristic_type);
                            setJuris_display("ทั่วไป");
                          }}
                        />
                      </FormBoot.Group>
                      {/* <FormBoot.Group
                        as={Col}
                        md="5"
                        style={{ padding: "0px" }}
                      >
                        <FormBoot.Check
                          //disabled
                          className="check-box"
                          id={"`inline-radio-2`"}
                          type="radio"
                          label="พิเศษ"
                          name="radioGroup"
                          defaultChecked={juristic_type === true}
                          onChange={() => {
                            setJuristic_type(!juristic_type);
                            setJuris_display("พิเศษ");
                          }}
                        />
                      </FormBoot.Group> */}
                    </Row>
                  </div>
                  <label>
                    ชื่อหน่วยงาน
                    <span
                      style={{
                        color: "#0077B6",
                        marginLeft: "10px",
                        fontWeight: "bold",
                      }}
                    >
                      {"( " + juris_display + " )"}
                    </span>
                  </label>
                  <Input
                    type="text"
                    className="form-control"
                    name="company_name"
                    value={company_name}
                    validations={[required]}
                    //placeholder="123xxxx456xxxx789"
                    onChange={onChangeCompany_name}
                    style={{
                      borderRadius: "10px",
                      boxShadow: "0px 2px 4px 1px rgba(0, 0, 0, 0.25)",
                      color: "#000000",
                    }}
                  />
                  <label htmlFor="idjur">เลขทะเบียนนิติบุคคล</label>
                  <Input
                    type="text"
                    className="form-control"
                    name="juristicID"
                    value={juristicID}
                    pattern="[0-9]*"
                    maxlength="13"
                    minLength="13"
                    //placeholder="123xxxx456xxxx789"
                    onChange={onChangeJuristic}
                    validations={[required]}
                    style={{
                      borderRadius: "10px",
                      boxShadow: "0px 2px 4px 1px rgba(0, 0, 0, 0.25)",
                      color: "#000000",
                    }}
                  />

                  <div style={{ display: "flex", marginTop: "10px" }}>
                    <label>รหัสสาขา (ภพ. 20) </label>
                    <span className="d-inline-block">
                      <span style={{ fontSize: "14px", color: "red" }}>
                        *ถ้ามี
                      </span>
                    </span>
                  </div>

                  <Input
                    type="text"
                    className="form-control"
                    // name="idnum"
                    value={branchID}
                    //placeholder="123xxxx456xxxx789"
                    onChange={onChangeBranchID}
                    style={{
                      borderRadius: "10px",
                      boxShadow: "0px 2px 4px 1px rgba(0, 0, 0, 0.25)",
                      color: "#000000",
                    }}
                  />

                  <label htmlFor="idnum">อีเมล</label>
                  <Input
                    type="text"
                    className="form-control"
                    name="identity"
                    value={identiy}
                    //placeholder="Identity_1234@gmail.com"
                    onChange={onChangeIdentity}
                    validations={[required]}
                    style={{
                      borderRadius: "10px",
                      boxShadow: "0px 2px 4px 1px rgba(0, 0, 0, 0.25)",
                      color: "#000000",
                    }}
                  />

                  <label htmlFor="password">รหัสผ่าน</label>
                  <Input
                    type="password"
                    className="form-control"
                    name="password"
                    value={password}
                    onChange={onChangePassword}
                    validations={[required, validate]}
                    placeholder=""
                    style={{
                      borderRadius: "10px",
                      boxShadow: "0px 2px 4px 1px rgba(0, 0, 0, 0.25)",
                      color: "#000000",
                    }}
                  />

                  <label htmlFor="password confirm">ยืนยันรหัสผ่าน</label>
                  <Input
                    type="password"
                    className="form-control"
                    name="password confirmation"
                    value={confirmpassword}
                    onChange={onChangeconfirmpassword}
                    validations={[required]}
                    placeholder=""
                    style={{
                      borderRadius: "10px",
                      boxShadow: "0px 2px 4px 1px rgba(0, 0, 0, 0.25)",
                      color: "#000000",
                    }}
                  />
                </div>
              </>
            )}

            <div className="form-group">
              <button
                className="custom-btn btnSave"
                style={{
                  width: "346px",
                  height: "67px",
                  fontSize: "26px",
                }}
              >
                ขึ้นทะเบียน
              </button>
            </div>

            <div style={{ display: "flex", justifyContent: "center" }}>
              <p>
                คุณมีบัญชีอยู่แล้วหรือไม่ ?{" "}
                <Link to={"/login"}>ลงชื่อเข้าใช้</Link>
              </p>
            </div>
          </div>

          {/* {message && (
            <div className="form-group">
              <div
                className={
                  successful ? "alert alert-success" : "alert alert-danger"
                }
                role="alert"
              >
                {message}
              </div>
            </div>
          )} */}
          <CheckButton style={{ display: "none" }} ref={checkBtn} />

          <Modal
            show={regisfail}
            centered
            onHide={handleClose}
            className="font-cen"
            //style={{ color: "red", background: "rgba(0,0,0,0.9)" }}
          >
            <Modal.Body
              style={{
                textAlign: "center",
                //background: "black",
                fontSize: "40px",
                borderRadius: "40px",
              }}
            >
              <img alt="" src={cancel} style={{ width: "40px" }} />
              <br />
              <h2 style={{ fontFamily: "Kanit" }}>บัตรประชาชนไม่ถูกต้อง</h2>
            </Modal.Body>
          </Modal>
          <Modal
            show={regissuccess}
            centered
            onHide={handleClose}
            className="font-cen"
            //style={{ color: "red", background: "rgba(0,0,0,0.9)" }}
          >
            <Modal.Body
              style={{
                textAlign: "center",
                //background: "black",
                fontSize: "40px",
                borderRadius: "40px",
              }}
            >
              {checkresendemail === true ? (
                "ส่งยืนยันอีเมลเรียบร้อย กรุณาเช็คที่อีเมลของท่าน"
              ) : (
                <>
                  <img alt="" src={check} style={{ width: "40px" }} />
                  <br />
                  <h2 style={{ fontFamily: "Kanit" }}>
                    ขึ้นทะเบียนสมาชิกเรียบร้อย
                  </h2>
                  <br />
                  <h2 style={{ fontFamily: "Kanit" }}>
                    กรุณายืนยันอีเมลก่อนใช้งาน
                  </h2>
                  <Button onclick={()=>handleresend()} style={{cursor:"pointer"}}>ส่งยืนยันอีเมลอีกครั้ง</Button>
                </>
              )}

              
            </Modal.Body>
            <Modal.Footer>
              <div style={{ alignContent: "center", display: "flex" }}>
                <button
                  onClick={() => {
                    navigate("/login");
                  }}
                >
                  ลงชื่อเข้าใช้
                </button>
              </div>
            </Modal.Footer>
          </Modal>

          <Modal
            show={errorin}
            centered
            onHide={handleClose}
            className="font-cen"
            //style={{ color: "red", background: "rgba(0,0,0,0.9)" }}
          >
            <Modal.Body
              style={{
                textAlign: "center",
                //background: "black",
                fontSize: "40px",
                borderRadius: "40px",
              }}
            >
              <img alt="" src={cancel} style={{ width: "40px" }} />
              <br />
              <h2 style={{ fontFamily: "Kanit" }}>{errorMsg}</h2>
            </Modal.Body>
          </Modal>

          <Modal
            show={checkpassworderror}
            centered
            onHide={handleClose}
            className="font-cen"
            //style={{ color: "red", background: "rgba(0,0,0,0.9)" }}
          >
            <Modal.Body
              style={{
                textAlign: "center",
                //background: "black",
                fontSize: "40px",
                borderRadius: "40px",
              }}
            >
              <img alt="" src={cancel} style={{ width: "40px" }} />
              <br />
              <h2 style={{ fontFamily: "Kanit" }}>รหัสผ่านไม่ตรงกัน</h2>
            </Modal.Body>
          </Modal>

          <Modal
            show={spinner}
            centered
            onHide={() => setSpinner(false)}
            className="font-cen"
            //style={{ color: "red", background: "rgba(0,0,0,0.9)" }}
          >
            <Modal.Body
              style={{
                textAlign: "center",
                //background: "black",
                fontSize: "40px",
                borderRadius: "40px",
              }}
            >
              <img alt="" src={spin} style={{ width: "40px" }} />
            </Modal.Body>
          </Modal>
        </Form>
      </div>
    </div>
  );
};

export default Register;
